import React, { useContext, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import MenuCard from '../MenuCard/MenuCard';
import 'swiper/css';
import { GeneralContext } from '../../../context/generalContext';
import { MenuContext } from '../../../context/menuContext';
import { addressesAPI } from '../../../services/GeneralService';
import classes from './MenuSection.module.scss';
import classesGeneral from '../MenuGeneral/MenuGeneral.module.scss';
import downloadIcon from '../../../images/icon-download.svg';
import { checkIsTashkent } from '../../../functions/checkCity/checkCity';

const langMapper = {
  priceText: [
    '',
    'Информация на сайте носит рекламный характер. Прейскурант находится в «Информационной папке потребителя» ресторанов. ',
    'The information on this site is a promotional material. Approved final menu you could find in informational consumer file in the restaurant. ',
  ],
  paymentText: [
    '',
    'Цены указаны в рублях. Оплата производится в рублях.',
    'All prices are indicated in Rubles. Payment is made in Rubles.',
  ],
  paymentTextUz: [
    '',
    'Цены указаны в узбекских сумах. Оплата производится в национальной валюте (узбекский Сум).',
    'Prices are indicated in Uzbek Som. Payment is made in the national currency (Uzbek Som).',
  ],
};

export default function MenuSection({ menuSectionsNotEmpty, menuItems, subSections1 }) {
  const { selectedMenuSection } = useContext(MenuContext);
  const { selectedAddress, windowWidth, activeLanguage } = useContext(GeneralContext);
  const { data: addresses } = addressesAPI.useFetchAllAddressesQuery();

  const [activeSubSection, setActiveSubSection] = useState(0);
  useEffect(() => {
    if (subSections1[0]) {
      setActiveSubSection(subSections1[0]?.id);
    }
  }, [subSections1]);

  const [topDescrRu, setTopDescrRu] = useState('');
  const [topDescrEn, setTopDescrEn] = useState('');
  const [bottomDescrRu, setBottomDescrRu] = useState('');
  const [bottomDescrEn, setBottomDescrEn] = useState('');
  useEffect(() => {
    const description = menuSectionsNotEmpty?.filter(sect => sect.id === selectedMenuSection)[0]?.description;

    if (description?.length) {
      const arr = [];
      description.forEach(element => {
        arr.push('true');
        if (element.top_description) {
          setTopDescrRu(element.top_description);
          setTopDescrEn(element.top_description_en || element.top_description);
        } else {
          setTopDescrRu('');
          setTopDescrEn('');
        }

        if (element.bottom_description) {
          setBottomDescrRu(element.bottom_description);
          setBottomDescrEn(element.bottom_description_en || element.bottom_description);
        } else {
          setBottomDescrRu('');
          setBottomDescrEn('');
        }
        // }
      });

      // если ресторана нет ни в одном элементе из массива description - сбрасываем текст
      if (!arr.includes('true')) {
        setTopDescrRu('');
        setTopDescrEn('');
        setBottomDescrRu('');
        setBottomDescrEn('');
      }
    } else {
      setTopDescrRu('');
      setTopDescrEn('');
      setBottomDescrRu('');
      setBottomDescrEn('');
    }
  }, [selectedMenuSection, selectedAddress, menuSectionsNotEmpty]);

  // из св-ва price выделяем уникальные цены и виды
  const handleItemChoices = item => {
    const choicesArr = [];
    // в случае если отдается массив
    if (item.price[0]) {
      item.price
        // .filter((el) => el.idRestaurant === selectedAddress)
        .forEach(element => {
          if (!choicesArr.find(el => el.name === element.choice)) {
            choicesArr.push({
              price: element.price,
              name: element.choice,
              name_en: element.choice_en || element.choice,
            });
          }
        });
    } else if (item.price) {
      choicesArr.push({
        price: item.price.price,
        name: item.price.choice || '',
        name_en: item.price.choice_en || item.price.choice || '',
      });
    }

    return choicesArr;
  };

  // принимает массив строк и фильтрует его по объему от меньшего к большему
  const sortDrinkChoices = (choicesArr, lang) => {
    const volumeMl = { ru: 'мл', en: 'ml' };
    const volumeLitre = { ru: 'л', en: 'l' };

    const mlArr = [];
    const litreArr = [];
    choicesArr?.forEach(choice => {
      if (choice?.split(' ')[1]?.toLowerCase() === 'ml' || choice?.split(' ')[1]?.toLowerCase() === 'мл') {
        mlArr.push(Number(choice?.split(' ')[0]));
      } else if (choice?.split(' ')[1]?.toLowerCase() === 'l' || choice?.split(' ')[1]?.toLowerCase() === 'л') {
        litreArr.push(Number(choice?.split(' ')[0]));
      }
    });

    const resultArr = [];
    mlArr.sort((a, b) => a - b);
    litreArr.sort((a, b) => a - b);
    mlArr.forEach(mlChoice => resultArr.push(`${mlChoice} ${volumeMl[lang]}`));
    litreArr.forEach(mlChoice => resultArr.push(`${mlChoice} ${volumeLitre[lang]}`));

    return resultArr;
  };

  // фильтрует позиции меню по id секции и по выбранному ресторану
  const filterItemsBySectionId = sectionId => menuItems.filter(item => item.menuSectionId === sectionId);

  // ищем в секции варианты объемов
  const handleSectionDrinkChoices = section => {
    const drinkChoices = { ru: [], en: [] };
    filterItemsBySectionId(section.id).forEach(menuItem => {
      const itemChoices = handleItemChoices(menuItem);
      itemChoices.forEach(choice => {
        if (!drinkChoices.ru.includes(choice.name)) {
          drinkChoices.ru.push(choice.name);
          drinkChoices.en.push(choice.name_en);
        }
      });
    });
    drinkChoices.ru = sortDrinkChoices(drinkChoices.ru, 'ru');
    drinkChoices.en = sortDrinkChoices(drinkChoices.en, 'en');

    // если на англ остался пустой массив
    if (drinkChoices.ru.length >= 1 && drinkChoices.en.length < 1) {
      drinkChoices.en = sortDrinkChoices(drinkChoices.ru, 'en');
    }

    return drinkChoices;
  };

  const [sectionDrinkChoices, setSectionDrinkChoices] = useState({});
  const [subSections2, setSubSections2] = useState([]);
  useEffect(() => {
    let subsectionsArr = [];
    if (subSections1.length) {
      subsectionsArr = subSections1?.map(item => ({ ...item, selected: false }));
    }
    // находим объемы позиций
    if (subsectionsArr.length > 0) {
      subsectionsArr.forEach(subsection => {
        if (menuSectionsNotEmpty.filter(section => section.id === selectedMenuSection)[0]?.tag === 'drink') {
          subsection.drinkChoices = handleSectionDrinkChoices(subsection);
        }
      });
    }
    setSubSections2(subsectionsArr);

    if (
      subsectionsArr.length < 1 &&
      menuSectionsNotEmpty.find(section => section.id === selectedMenuSection)?.tag === 'drink'
    ) {
      setSectionDrinkChoices(
        handleSectionDrinkChoices(menuSectionsNotEmpty.find(section => section.id === selectedMenuSection)),
      );
    } else {
      setSectionDrinkChoices({ ru: [], en: [] });
    }
  }, [selectedMenuSection, menuSectionsNotEmpty, subSections1]);

  return (
    <>
      {!topDescrRu && subSections1.length < 1 && (
        <>
          {windowWidth > 767 && (
            <div className={classes.menuHeaderDiv}>
              <h1 className={classes.menuHeader2}>
                {activeLanguage === 1
                  ? menuSectionsNotEmpty?.find(section => section.id === selectedMenuSection)?.name
                  : menuSectionsNotEmpty?.find(section => section.id === selectedMenuSection)?.name_en ||
                    menuSectionsNotEmpty?.find(section => section.id === selectedMenuSection)?.name}
              </h1>
              {sectionDrinkChoices?.ru && sectionDrinkChoices.ru.length <= 2 && (
                <p className={classes.priceChoice}>{sectionDrinkChoices.ru.join(' / ')}</p>
              )}
            </div>
          )}
          {/* Арбатская и Ульянова при выбранной секции пицца */}
          <div
            className={selectedMenuSection === 372 && selectedAddress === 40523 ? classes.disclaimer : classes.disabled}
          >
            {activeLanguage === 1
              ? 'Мы готовим пиццу по субботам и воскресеньям'
              : 'We cook pizza on Saturdays and Sundays'}
          </div>
          <div
            className={selectedMenuSection === 372 && selectedAddress === 3344 ? classes.disclaimer : classes.disabled}
          >
            {activeLanguage === 1
              ? 'Мы готовим пиццу со среды по воскресенье'
              : 'We cook pizza from Wednesday to Sunday'}
          </div>
          <div
            className={topDescrRu ? 'lunch-cards' : classes.menuItems}
            style={
              menuSectionsNotEmpty.find(section => section.id === selectedMenuSection)?.tag === 'drink'
                ? { flexDirection: 'column' }
                : {}
            }
          >
            {menuItems?.length > 0 &&
              menuItems?.map(item => (
                <MenuCard
                  key={item.id}
                  item={item}
                  topDescrRu={topDescrRu}
                  showChoice={sectionDrinkChoices?.ru?.length > 2}
                  handleItemChoices={handleItemChoices}
                  menuSectionsNotEmpty={menuSectionsNotEmpty}
                />
              ))}
          </div>
        </>
      )}

      {!topDescrRu && subSections1.length === 1 && (
        <>
          {windowWidth > 767 && (
            <div className={classes.menuHeaderDiv}>
              <h1 className={classes.menuHeader2}>
                {activeLanguage === 1 ? subSections1[0]?.name : subSections1[0]?.name_en || subSections1[0]?.name}
              </h1>
              {subSections2[0]?.drinkChoices?.ru.length <= 2 && (
                <p className={classes.priceChoice}>{subSections2[0]?.drinkChoices?.ru.join(' / ')}</p>
              )}
            </div>
          )}
          <div
            className={topDescrRu ? 'lunch-cards' : classes.menuItems}
            style={
              menuSectionsNotEmpty.find(section => section.id === selectedMenuSection)?.tag === 'drink'
                ? { flexDirection: 'column' }
                : {}
            }
          >
            {menuItems?.length > 0 &&
              menuItems
                .filter(item => item.menuSectionId === subSections1[0]?.id)
                ?.map(item => (
                  <MenuCard
                    key={item.id}
                    item={item}
                    topDescrRu={topDescrRu}
                    showChoice={subSections2[0]?.drinkChoices?.ru?.length > 2}
                    handleItemChoices={handleItemChoices}
                    menuSectionsNotEmpty={menuSectionsNotEmpty}
                  />
                ))}
          </div>
        </>
      )}

      {!topDescrRu && subSections1.length > 1 && (
        <>
          <div className={classes.subSections}>
            <Swiper
              className={classes.subSectionsSlider}
              modules={[Navigation]}
              watchOverflow
              spaceBetween={32}
              slidesPerView='auto'
              navigation
            >
              {subSections1?.map(subSection => (
                <SwiperSlide className={classes.subSectionsSlideItem} key={subSection.id}>
                  <a
                    href={`#subsection-${subSection.id}`}
                    // key={subSection.id}
                    onClick={() => setActiveSubSection(subSection.id)}
                    className={activeSubSection === subSection.id ? classes.subSectionActive : classes.subSection}
                  >
                    {activeLanguage === 1 ? subSection.name : subSection.name_en || subSection.name}
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          {subSections2?.map(subSection => (
            <div key={subSection.id} className={classes.subSectionDiv}>
              <div className={classes.subSectionHeaderDiv}>
                <div className={classes.subSectionTitle} id={`subsection-${subSection.id}`}>
                  {activeLanguage === 1 ? subSection.name : subSection.name_en || subSection.name}
                </div>
                {subSection.drinkChoices?.ru.length <= 2 && (
                  <p className={classes.priceChoice}>{subSection.drinkChoices.ru.join(' / ')}</p>
                )}
              </div>
              <div
                className={topDescrRu ? 'lunch-cards' : classes.menuItems}
                style={
                  menuSectionsNotEmpty.find(section => section.id === selectedMenuSection)?.tag === 'drink'
                    ? { flexDirection: 'column' }
                    : {}
                }
              >
                {menuItems?.length > 0 &&
                  menuItems
                    .filter(item => item.menuSectionId === subSection.id)
                    .map(item => (
                      <MenuCard
                        key={item.id}
                        item={item}
                        topDescrRu={topDescrRu}
                        showChoice={subSection.drinkChoices?.ru?.length > 2}
                        handleItemChoices={handleItemChoices}
                        menuSectionsNotEmpty={menuSectionsNotEmpty}
                      />
                    ))}
              </div>
            </div>
          ))}
        </>
      )}

      {topDescrRu && (
        <>
          <div className={classes.menuHeaderDiv}>
            <h1 className={classes.menuHeader2}>
              {activeLanguage === 1
                ? menuSectionsNotEmpty?.find(section => section.id === selectedMenuSection)?.name
                : menuSectionsNotEmpty?.find(section => section.id === selectedMenuSection)?.name_en ||
                  menuSectionsNotEmpty?.find(section => section.id === selectedMenuSection)?.name}
            </h1>
          </div>
          <p
            className={classes.topDescription}
            dangerouslySetInnerHTML={{ __html: activeLanguage === 1 ? topDescrRu : topDescrEn }}
          />
        </>
      )}

      <div className={topDescrRu ? classesGeneral.menuDownloadBtnLunch : classes.disabled}>
        <a
          href={
            activeLanguage === 1
              ? addresses?.filter(address => address.id === selectedAddress)[0]?.menu
              : addresses?.filter(address => address.id === selectedAddress)[0]?.menu_en ||
                addresses?.filter(address => address.id === selectedAddress)[0]?.menu
          }
          target='_blank'
          rel='noreferrer'
        >
          <img className={classesGeneral.menuDownloadBtnIcon} src={downloadIcon} alt='download icon' />
          <span className={classesGeneral.menuDownloadBtnText}>
            {activeLanguage === 1 ? 'Скачать меню' : 'Download menu'}
          </span>
        </a>
      </div>

      {bottomDescrRu && (
        <p
          className={classes.bottomDescription}
          dangerouslySetInnerHTML={{ __html: activeLanguage === 1 ? bottomDescrRu : bottomDescrEn }}
        />
      )}

      <div className={classesGeneral.menuInformation}>
        <p className={classesGeneral.menuInformationText}>
          {langMapper.priceText[activeLanguage]}
          {checkIsTashkent() ? langMapper.paymentTextUz[activeLanguage] : langMapper.paymentText[activeLanguage]}
        </p>
        <a
          href={
            activeLanguage === 1
              ? addresses?.filter(address => address.id === selectedAddress)[0]?.menu
              : addresses?.filter(address => address.id === selectedAddress)[0]?.menu_en ||
                addresses?.filter(address => address.id === selectedAddress)[0]?.menu
          }
          className={topDescrRu ? classes.disabled : classesGeneral.menuDownloadBtn}
          target='_blank'
          rel='noreferrer'
        >
          <div>
            <img className={classesGeneral.menuDownloadBtnIcon} src={downloadIcon} alt='download icon' />
            <span className={classesGeneral.menuDownloadBtnText}>
              {activeLanguage === 1 ? 'Скачать меню' : 'Download menu'}
            </span>
          </div>
        </a>
      </div>
    </>
  );
}
